import { render, staticRenderFns } from "./PromoTournaments.vue?vue&type=template&id=35ac54b5"
import script from "./PromoTournaments.vue?vue&type=script&lang=js"
export * from "./PromoTournaments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports